import { useContext, computed } from '@nuxtjs/composition-api';
import { useStore } from '~/composables/useStore';
import { DistributionCourseInfo } from '~/types/modules/order';
import { useOrderConversion } from './useOrderConversion';

export const useCriteoTag = () => {
  const store = useStore();
  const { $device } = useContext();
  const { orderedDetails } = useOrderConversion();

  const deviceType = computed(() => {
    if ($device.isMobile) {
      return 'm';
    }
    if ($device.isTablet) {
      return 't';
    }
    return 'd';
  });

  const baseEventObj = [
    // アカウントは固定
    { event: 'setAccount', account: 6938 },
    { event: 'setSiteType', type: deviceType.value },
  ];
  const emailEventObj = { event: 'setEmail', email: store.state.user.info.userBase?.loginId || '' };

  const setTopTag = () => {
    if (!window.criteo_q) {
      return;
    }
    window.criteo_q.push(...baseEventObj, emailEventObj, { event: 'viewHome' });
  };
  const setItemListTag = (codeList: string[]) => {
    if (!window.criteo_q) {
      return;
    }
    window.criteo_q.push(...baseEventObj, emailEventObj, { event: 'viewList', item: codeList });
  };
  const setItemDetailTag = (code: string) => {
    if (!window.criteo_q) {
      return;
    }
    window.criteo_q.push(...baseEventObj, emailEventObj, { event: 'viewItem', item: code });
  };
  const setCartTag = () => {
    if (!window.criteo_q) {
      return;
    }
    const cartItems = store.state.modules.cart.carts.flatMap((cart) =>
      cart.items.map((item) => ({ id: item.product_code, price: item.price, quantity: item.quantity }))
    );
    window.criteo_q.push(...baseEventObj, emailEventObj, { event: 'viewBasket', item: cartItems });
  };
  const setOrderCompleteTag = () => {
    if (!window.criteo_q) {
      return;
    }

    const { cart, orderId } = orderedDetails.value;
    const orderItems =
      cart?.items.map((item) => ({ id: item.product_code, price: item.price, quantity: item.quantity })) || [];
    window.criteo_q.push(...baseEventObj, { event: 'trackTransaction', id: orderId, item: orderItems });
  };
  const setDistributionCompleteTag = (item: DistributionCourseInfo | null, subscriptionId: number | null) => {
    if (!window.criteo_q || !item || !subscriptionId) {
      return;
    }

    const orderItem = { id: item.product_code_s, price: item.lowest_price_general_i, quantity: 1 };
    window.criteo_q.push(...baseEventObj, { event: 'trackTransaction', id: subscriptionId, item: [orderItem] });
  };

  return {
    setTopTag,
    setItemListTag,
    setItemDetailTag,
    setCartTag,
    setOrderCompleteTag,
    setDistributionCompleteTag,
  };
};
